import React from 'react';
import ReactDOM from 'react-dom';
import WOW from 'wow.js';
import App from './find-a-hotel/App';
import HotelOffers from './offers-filter/components/HotelOffers';
import bookingConsole from './components/bookingConsole';
import filterLocations from './components/filterLocations';
import propertyLevel from './components/propertyLevel';
import SlickSlider from "./components/slickSlider";
import ContentPush from "./components/ContentPush";
import Gallery from "./media-gallery/gallery";
import {checkBandwidthSpeed, setAttrTabs} from "./utils/index";
// import ContentPushReviews from "./components/ContentPush";
import { getLocations, getMediaGallery, getAccommodationSilder, getHistorySilder, getGolfSilder, getAccommodationPushmarket, getReviewsPushMarket, getOverviewPushMarket, getTimelineHistorySilder, getTimelineGolfSilder, getDiningPushMarket, getLocationPushMarket, getMeetingsPushMarket, getCafeduparcPushMarket} from './api';
import './components/filtering';
import './components/forms';
import './components/header';
import './components/press';
import './components/specialOccasions';
// import TwitterWidget from './components/TwitterWidget'
// import FacebookWidget from './components/FacebookWidget';
// import { getAccommodation } from './api';

const isDevelopmentMode = false; //Enable this flag to see console logs on dev environment
if(!isDevelopmentMode){
  if(!window.console) window.console = {};
  var methods = ["log", "debug", "warn", "info"];
  for(var i=0;i<methods.length;i++){
      console[methods[i]] = function(){};
  }
}
var loadedLocations = false;
const app = {
  init() {
    const wow = new WOW({
      animateClass: 'animated',
      offset: 0
    });
    wow.init();

    this.loadLocations();
    this.findAHotelEvents();
    this.filterHotelOffersEvents();
    this.reactFunctionalities();


  },

  reactFunctionalities(){

            if ($('body').hasClass('accommodations')) {
      getAccommodationSilder().then(res => {
        const sliderData = res;
        this.getSlickSlider = function() {
          ReactDOM.render(
              <SlickSlider
              sliderData={sliderData}
              />,
              document.getElementById('react-slick')
          );
        };
        this.getSlickSlider();
      });
    }

    if ($('body').hasClass('history')) {
      getHistorySilder().then(res => {
        const sliderData = res;
        this.getHistorySlickSlider = function() {
          ReactDOM.render(
              <SlickSlider
              sliderData={sliderData}
              />,
              document.getElementById('history-react-slick')
          );
        };
        this.getHistorySlickSlider();
      });

      getTimelineHistorySilder().then(res => {
        const sliderData = res;
        this.getTimelineHistorySlickSlider = function() {
          ReactDOM.render(
              <SlickSlider
              sliderData={sliderData}
              />,
              document.getElementById('history-react-slick-2')
          );
        };
        this.getTimelineHistorySlickSlider();
      });

    }

    if ($('body').hasClass('golf')) {
      getGolfSilder().then(res => {
        const sliderData = res;
        this.getGolfSlickSlider = function() {
          ReactDOM.render(
              <SlickSlider
                  sliderData={sliderData}
              />,
              document.getElementById('golf-react-slick')
          );
        };
        this.getGolfSlickSlider();
      });

      getTimelineGolfSilder().then(res => {
        const sliderData = res;
        this.getTimelineGolfSlickSlider = function() {
          ReactDOM.render(
              <SlickSlider
                  sliderData={sliderData}
              />,
              document.getElementById('golf-react-slick-2')
          );
        };
        this.getTimelineGolfSlickSlider();
      });
    }

    var isAmerica='';
    if ($('body').hasClass('accommodations')) {
      if (window.location.href.includes('/us/')) {
        isAmerica = '/us';
      }
      getAccommodationPushmarket('accommodations',isAmerica).then(res => {
        const pushData = res;
        this.getPushMarketing = function() {
          ReactDOM.render(
              <ContentPush
                  pushData={pushData}
              />,
              document.getElementById('react-content-push-accommodations')
          );
        };
        this.getPushMarketing();
      });
    }

    if ($('body').hasClass('reviews')) {
      if (window.location.href.includes('/us/')) {
        isAmerica = '/us';
      }
      getReviewsPushMarket('reviews',isAmerica).then(res => {
        const pushData = res;
        this.getPushMarketing = function() {
          ReactDOM.render(
              <ContentPush
                  pushData={pushData}
              />,
              document.getElementById('react-content-push-reviews')
          );
        };
        this.getPushMarketing();
      });
    }

    if ($('body').hasClass('overview')) {
      if (window.location.href.includes('/us/')) {
        isAmerica = '/us';
      }
      getOverviewPushMarket('overview',isAmerica).then(res => {
        const pushData = res;
        this.getPushMarketing = function() {
          ReactDOM.render(
              <ContentPush
                  pushData={pushData}
              />,
              document.getElementById('react-content-push-overview')
          );
        };
        this.getPushMarketing();
      });
    }

    if($('#media-gallery-wrap').hasClass('media-gallery')) {
      // const imagesData = [
      //   {
      //     "img": "../../templates/images/media_gallery/01.jpg",
      //     "imgFull": "../../templates/images/media_gallery/01.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "General",
      //     "video": "https://historichotels.sabredemos.com/templates/videos/hhw-homepage.mp4",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }      
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/04.jpg",
      //     "imgFull": "../../templates/images/media_gallery/04.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Accommodations",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/05.jpg",
      //     "imgFull": "../../templates/images/media_gallery/05.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Culinary & Dining",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/06.jpg",
      //     "imgFull": "../../templates/images/media_gallery/06.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Meetings & Reunions",
      //     "video": "https://player.vimeo.com/video/93592225",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   },
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/07.jpg",
      //     "imgFull": "../../templates/images/media_gallery/07.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Location",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/08.jpg",
      //     "imgFull": "../../templates/images/media_gallery/08.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Activities",
      //     "video": "https://www.youtube.com/embed/yMMtdjtT0X4",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/09.jpg",
      //     "imgFull": "../../templates/images/media_gallery/09.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "History",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/10.jpg",
      //     "imgFull": "../../templates/images/media_gallery/10.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "General",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/11.jpg",
      //     "imgFull": "../../templates/images/media_gallery/11.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Accommodations",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/12.jpg",
      //     "imgFull": "../../templates/images/media_gallery/12.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Culinary & Dining",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/13.jpg",
      //     "imgFull": "../../templates/images/media_gallery/13.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Meetings & Reunions",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/14.jpg",
      //     "imgFull": "../../templates/images/media_gallery/14.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Location",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   },
      //   {
      //     "img": "../../templates/images/media_gallery/15.jpg",
      //     "imgFull": "../../templates/images/media_gallery/15.jpg",
      //     "title": "Willard InterContinental Historical Rendering",
      //     "description": "Optional short descriptive content goes here",
      //     "category": "Activities",
      //     "socialConfig": {
      //       "socialShareHashTag": [
      //           "#HHA", "#HHW"
      //       ],
      //       "socialShareTitle": "Historic Awesomeness",
      //       "socialShareUrl": "https://historichotels.sabredemos.com",
      //       "socialShareBody": "Historic Hotels of America"
      //   }
      //   }        
      // ]
      const isLowBandwidth = checkBandwidthSpeed();
      isLowBandwidth.then(function(flag){
        if(flag === undefined) {
          flag =  false;
        }
        console.log("This is the bandwidth flag! is low ? " + flag);
        getMediaGallery(flag).then(response => {
          console.log('Response for Media Gallery from API' +response);
          ReactDOM.render(
            <Gallery api='4a742055-cebe-4abe-be38-edc9e20051d8' images={response} imageWidth={388.5}  allowFullScreenZoom={true}/>,
            document.getElementById('gallery-media-widget')
          );
          $(document).on('click', '.scaled-light-box', function() {
              $('.shs-widgets-gallery--modal').addClass('full-widgets-gallery--modal');
          });
          $(document).on('click', '.full-light-box', function(e) {
            if (!$(e.target).is('.full-widgets-gallery--modal'))
              $('.full-widgets-gallery--modal').removeClass('full-widgets-gallery--modal');
          })
          $(document).on('click', '.share-icons.download', function(e) {
            let imgURL = $('.shs-widgets-gallery--modal .detail-image img').prop('src');
            if(imgURL) {
              e.target.href = imgURL;
            } else {
              let videoURL = $('.shs-widgets-gallery--modal .detail-image video').prop('src');
              if(videoURL) {
                window.URL = window.URL || window.webkitURL;
                var xhr = new XMLHttpRequest(),
                  a = document.createElement("a"),
                  file;
                xhr.open("GET", videoURL, true);
                xhr.responseType = "blob";
                xhr.onload = function() {
                  file = new Blob([xhr.response], {
                    type: "application/octet-stream"
                  });
                  a.href = window.URL.createObjectURL(file);
                  a.download = xhr.responseURL.split('/').pop();
                  a.click();
                };
                xhr.send();
              } else { 
                let ptag = document.createElement('p');
                ptag.className = "download-error-msg hide";
                ptag.innerText= "This video is not downloadable"
                $('.social-share').append(ptag)
                ptag.classList.remove('hide');
                setTimeout(function() {
                  ptag.classList.add('hide');
                }, 5000)
              }
              e.preventDefault();
              e.stopPropagation();
              return
            }
          })
          $(".spinner").remove();
        });
      });
      console.log('Media Gallery exists !!!');
    }
    $('.sidebar .feature-widget-slider .offer.slick-slide').removeAttr('aria-describedby');
    if ($('body').hasClass('dining')) {
      if (window.location.href.includes('/us/')) {
        isAmerica = '/us';
      }
      getDiningPushMarket('dining',isAmerica).then(res => {
        const pushData = res;
        this.getPushMarketing = function() {
          ReactDOM.render(
              <ContentPush
                  pushData={pushData}
              />,
              document.getElementById('react-content-push-culinary')
          );
        };
        this.getPushMarketing();
      });
    }

    if ($('body').hasClass('location')) {
      if (window.location.href.includes('/us/')) {
        isAmerica = '/us';
      }
      getLocationPushMarket('location',isAmerica).then(res => {
        const pushData = res;
        this.getPushMarketing = function() {
          ReactDOM.render(
              <ContentPush
                  pushData={pushData}
              />,
              document.getElementById('react-content-push-location')
          );
        };
        this.getPushMarketing();
      });
    }

    if ($('body').hasClass('special-occasions')) {
      if (window.location.href.includes('/us/')) {
        isAmerica = '/us';
      }
      getMeetingsPushMarket('meetings',isAmerica).then(res => {
        const pushData = res;
        this.getPushMarketing = function() {
          ReactDOM.render(
          <ContentPush
          pushData={pushData}
          />,
          document.getElementById('react-content-push-meetings')
        );
        };
        this.getPushMarketing();
      });
    }

    if ($('body').hasClass('cafe')) {
      if (window.location.href.includes('/us/')) {
        isAmerica = '/us';
      }
      getCafeduparcPushMarket('cafe-du-parc',isAmerica).then(res => {
        const pushData = res;
        this.getPushMarketing = function() {
          ReactDOM.render(
          <ContentPush
          pushData={pushData}
          />,
          document.getElementById('react-content-push-cafeduparc')
        );
        };
        this.getPushMarketing();
      });
    }


    // this.getTwitterWidget = function() {
      //   ReactDOM.render(
      //     <TwitterWidget />,
      //     document.getElementById('twitterWidget')
      //   );
      // };
 
      // this.getTwitterWidget();
 
      // this.getFacebookWidget = function() {
      //   ReactDOM.render(
      //     <FacebookWidget />,
      //     document.getElementById('FacebookWidget')
      //   );
      // };
 
      // this.getFacebookWidget();

     

      this.getContentPush = function() {
        ReactDOM.render(
            <ContentPush />,
            document.getElementById('react-content-push')
        );
      };

      if ($('body').hasClass('react-content-push')) {
        this.getContentPush();
      }

      this.getContentPushReviews = function() {
        ReactDOM.render(
            <ContentPush />,
            document.getElementById('react-content-push-reviews')
        );
      };

      if ($('body').hasClass('react-content-push-reviews')) {
        this.getContentPushReviews();
      }


  },

  filterHotelOffersEvents() {
    const _this = this;
    $('#triggerFilter').on('click touch', function() {
      if(_this.getHotelOffers === 'undefined') {
        return ;
      }
      _this.getHotelOffers();
      setAttrTabs();
      $('.close-x').focus();
      $('.content-search-widget-content').fadeIn().addClass('modal-filter-open')
    });

    $('.content-search-widget-content .close-x').on('click', function() {
      $('.content-search-widget-content').fadeOut(300, function() {
        $(this).removeClass('modal-filter-open');
      });
    });

  },


  findAHotelEvents() {
    const _this = this;
    // Find a hotel
    $('.toggle-find-a-hotel').on('click', function() { 
      _this.loadLocations();
      
      $('#modal-find-a-hotel').fadeIn().addClass('modal-console-open');
      $('#modal-find-a-hotel .modal-logo').focus();
      setAttrTabs();
      $('body').addClass('modal-fixed');

      if ($('#find-a-hotel').val() === '') {
        $('.placeholder-primary').removeClass('hide');
        $('.placeholder-secondary').removeClass('hide');
      } else {
        /*$('.placeholder-primary').addClass('hide');
          $('.placeholder-secondary').addClass('hide');*/
      }

      // var ua = window.navigator.userAgent;
      // var isIE = /MSIE|Trident/.test(ua);
      // if ( isIE ) {
      // console.log('inside');
      // $('.find-a-hotel').on(focus,function() {
      //   $('.find-a-hotel').blur();
      // })
    //  }
     

      // setTimeout(() => {
      //   window.location.hash = '#find-a-hotel';
     
      //   const findAHotelTabs = document.getElementById('find-a-hotel-tabs');

      //   if (findAHotelTabs) {
      //     findAHotelTabs.scrollIntoView({
      //       block: 'end',
      //       inline: 'nearest'
      //     });
      //   }
      // }, 0);
    });

    // Close Find a hotel Modal Console
    $('#modal-find-a-hotel .btn-close').on('click', function() {
      $('.nav-global-btn-close-menu').click();

      $('#modal-find-a-hotel').fadeOut(300, function() {
        $(this).removeClass('modal-console-open');
      });
      $('body').removeClass('modal-fixed');

      window.location.hash = '';
    });
    $('#top-bar-find-a-hotel li a').keypress(function(e) {
        if (e.which == 13) {
          setAttrTabs();
        }
    });
  },


  loadLocations() {

    if(loadedLocations) {
      return false;
    }
    
    const pathIcons = '/templates/images/icons';
    const themes = [
      {
        alt: 'red map marker icon',
        googleMapsSrc: `${pathIcons}/icon-google-map-red.svg`,
        src: `${pathIcons}/icon-map-marker-red.svg`
      },
      {
        alt: 'blue map marker icon',
        googleMapsSrc: `${pathIcons}/icon-google-map-blue.svg`,
        src: `${pathIcons}/icon-map-marker-blue.svg`
      }
    ];

    function selectTheme() {
      if (window.location.pathname.indexOf('/us') > -1) {
        return 0;
      } else {
        return 1;
      }
    }

    const theme = themes[selectTheme()];

    getLocations().then(xml => {
      const GOOGLE_MAPS_API_KEY = 'AIzaSyDoe_e0YIlgkhMQETmMXtdWiK1dNr1ow4Y';
      const {
        allPlaces,
        experiences,
        hotels,
        locations,
        tags,
        allPlacesWidget
      } = filterLocations(xml);
      

      function getPropertyLevel() {
        propertyLevel.init({
          API_KEY: GOOGLE_MAPS_API_KEY,
          hotels,
          theme
        });
      }

      if ($('body').hasClass('property') && !$('body').hasClass('location-exists')) {
        getPropertyLevel();
      }

      bookingConsole.init(hotels, locations);

      this.getFindAHotel = function() {
        if (!$('body').hasClass('location') || $('body').hasClass('location-exists')){
          ReactDOM.render(
              <App
                  API_KEY={GOOGLE_MAPS_API_KEY}
                  allPlaces={allPlaces}
                  experiences={experiences}
                  hotels={hotels}
                  tags={tags}
                  theme={theme}
              />,
              document.getElementById('search-panels')
          );
        }
      };

      this.loadLocations = this.loadLocations.bind(this);

      this.getFindAHotel();

      this.getHotelOffers = function() {
        ReactDOM.render(
            <HotelOffers
              allPlaces={allPlacesWidget}
              theme={theme}
          />, document.getElementById('offers-fliter')
        );
      };
      this.getHotelOffers.call(this);
      if (window.location.hash === '#find-a-hotel') {
        setTimeout(() => {
          $('.toggle-find-a-hotel').click();
        }, 10000);
      }

      if ($(document.body).hasClass('property')) {
        getPropertyLevel();
      }
    });

    loadedLocations = true;

  }
};

app.init();


